import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import DOMUtils from '@spothero/utils/dom';
import SearchUtils from 'search-utils';
import SHUtils from 'utils';
import Button from 'button-component';
import Icon from 'icon-component';
import SHGlobals from 'sh-globals';
import Config from 'global/common/Config';
import GooglePlacesSearchInput from 'search/components/common/GooglePlacesSearchInput';
import DateTimePickers from 'datetime/components/common/DateTimePickers';

const WIDGET_DISPLAY_TIME_FORMAT = 'MMM D, hh:mmA';

class SearchControls extends Component {
    constructor(props) {
        super(props);

        const {
            transientStart,
            transientEnd,
            monthlyStart,
            hourSpan,
            searchString
        } = props;

        this._onBodyClick = this._onBodyClick.bind(this);
        this._onHoursClick = this._onHoursClick.bind(this);
        this._onSuggestSelect = this._onSuggestSelect.bind(this);
        this._onDateTimePickersChange = this._onDateTimePickersChange.bind(this);
        this._onSearchClear = this._onSearchClear.bind(this);
        this._onSearchClick = this._onSearchClick.bind(this);

        this.state = {
            open: false,
            locationData: null,
            starts: transientStart,
            ends: transientEnd,
            monthly_start_date: monthlyStart,
            hourSpan,
            isTransientStartValid: true,
            currentSearch: searchString
        };
    }

    componentWillReceiveProps(nextProps) {
        const {
            searchString
        } = nextProps;

        if (this.state.currentSearch !== searchString) {
            this.setState({
                currentSearch: searchString,
                locationData: null
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            open
        } = this.state;

        if (prevState.open !== open) {
            if (open) {
                document.body.addEventListener('click', this._onBodyClick);
            } else {
                document.body.removeEventListener('click', this._onBodyClick);
            }
        }
    }

    _onBodyClick(evt) {
        if (!DOMUtils.parent(evt.target, '.SH-SearchControls')
            && !DOMUtils.parent(evt.target, '.DatePicker-tether')
            && !DOMUtils.parent(evt.target, '.TimePicker-tether')) {
            this.setState({
                open: false
            });
        }
    }

    _onHoursClick() {
        this.setState({
            open: !this.state.open
        });
    }

    _onSuggestSelect({label, location, placeId, placesPlaceId, reference}) {
        this.setState({
            locationData: {
                latitude: location.lat,
                longitude: location.lng,
                places_id: placeId,
                places_place_id: placesPlaceId,
                places_reference: reference,
                search_string: label
            }
        });
    }

    _onDateTimePickersChange({transientStart, transientEnd, monthlyStart, isValidStart}) {
        const {
            serverDateTimeFormat
        } = this.props;

        if (isValidStart) {
            this.setState({
                starts: transientStart.format(serverDateTimeFormat),
                ends: transientEnd.format(serverDateTimeFormat),
                monthly_start_date: monthlyStart.format(serverDateTimeFormat),
                hourSpan: parseFloat(SHUtils.prettyDuration(transientEnd.diff(transientStart), true), 10),
                isTransientStartValid: isValidStart
            });
        }
    }

    _onSearchClear() {
        this.setState({
            currentSearch: '',
            locationData: null
        });
    }

    _onSearchClick() {
        const {
            isMonthly,
            onMultiOrNoResultsFound,
            onNewSearch
        } = this.props;
        const {
            starts,
            ends,
            monthly_start_date,
            locationData,
            currentSearch
        } = this.state;
        const value = this._googleSearch.refs.autosuggest.state.value;
        let data = (!isMonthly)
            ?
                {
                    starts,
                    ends,
                    monthly_start_date: null,
                    eid: null
                }
            :
                {
                    starts: null,
                    ends: null,
                    monthly_start_date,
                    eid: null
                };

        if (locationData) {
            data = {
                ...data,
                ...locationData
            };
        }

        if (!isEmpty(value) && currentSearch !== value && !locationData) {
            SearchUtils.geocode(value, results => {
                if (isArray(results)) {
                    // no results or more than one result found, show dialog
                    onMultiOrNoResultsFound(results, data);
                } else {
                    // single result found, add it to the new search data
                    data = {
                        ...data,
                        ...results
                    };

                    onNewSearch(data);
                }
            });
        } else {
            onNewSearch(data);
        }

        this.setState({
            open: false,
            locationData: null
        });
    }

    _renderMonthlyControls() {
        const {
            monthly_start_date,
            currentSearch
        } = this.state;
        const monthlyStartFormatted = (monthly_start_date)
            ? moment.tz(
                monthly_start_date.split('T')[0],
                SHGlobals.MOBILE_DATE_FORMAT,
                window.currentCityTimezone
            ).format(SHGlobals.MOBILE_DATE_FORMAT)
            : null;
        let placeholder = 'Search Address';

        return (
            <div className="SH-SearchControls-container-monthly">
                <div className="SH-SearchControls-search-month-start datetime-range-picker-container">
                    <DateTimePickers
                        isMonthly
                        monthlyStarts={monthlyStartFormatted}
                        monthlyStartDateLabel="Monthly Parking Start Date"
                        onChange={this._onDateTimePickersChange}
                        tooltipPosition="bottom"
                        useCalendarWithShim
                    />
                </div>
                <div className="SH-SearchControls-monthly-search-bar">
                    <GooglePlacesSearchInput
                        ref={node => { this._googleSearch = node; }}
                        placeholder={placeholder}
                        value={currentSearch}
                        size="lg"
                        onSuggestionSelect={this._onSuggestSelect}
                        onClear={this._onSearchClear}
                    />
                </div>
                <div className="SH-SearchControls-monthly-search-button">
                    <Button
                        color="primary"
                        size="lg"
                        block
                        onClick={this._onSearchClick}
                    >
                        Find Parking
                    </Button>
                </div>
            </div>
        );

    }

    _renderControls() {
        const {
            isMonthly
        } = this.props;
        const {
            isTransientStartValid,
            starts,
            ends,
            currentSearch
        } = this.state;
        const placeholder = 'Search Address or Event';

        if (isMonthly) {
            return this._renderMonthlyControls();
        }

        return (
            <div className="SH-SearchControls-container">
                <div className="SH-SearchControls-actions">
                    <div className="SH-SearchControls-search-info">
                        <div className="SH-SearchControls-search-datetime datetime-range-picker-container">
                            <DateTimePickers
                                isMonthly={false}
                                transientStarts={starts}
                                transientEnds={ends}
                                startDateLabel="Start Time"
                                endDateLabel="End Time"
                                onChange={this._onDateTimePickersChange}
                                tooltipPosition="bottom"
                                useCalendarWithShim
                            />
                        </div>
                        <div className="SH-SearchControls-search-bar">
                            <GooglePlacesSearchInput
                                ref={node => { this._googleSearch = node; }}
                                placeholder={placeholder}
                                value={currentSearch}
                                size="lg"
                                onSuggestionSelect={this._onSuggestSelect}
                                onClear={this._onSearchClear}
                            />
                        </div>
                    </div>
                    <div className="SH-SearchControls-search-button">
                        <Button
                            color="primary"
                            disabled={!isTransientStartValid}
                            size="lg"
                            block
                            onClick={this._onSearchClick}
                        >
                            Find Parking
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            isMonthly,
            destinationData,
            onVenueSearchClick
        } = this.props;
        const {
            starts,
            ends,
            open,
            monthly_start_date
        } = this.state;
        const monthlyStartFormatted = (monthly_start_date)
            ? moment.tz(
                monthly_start_date.split('T')[0],
                SHGlobals.MOBILE_DATE_FORMAT,
                window.currentCityTimezone
            ).format('MMM D, YYYY')
            : null;
        const startsFormatted = (starts)
            ? moment.tz(
                starts,
                SHGlobals.SERVER_DATE_TIME_FORMAT,
                window.currentCityTimezone
            ).format(WIDGET_DISPLAY_TIME_FORMAT)
            : null;
        const endsFormatted = (ends)
            ? moment.tz(
                ends,
                SHGlobals.SERVER_DATE_TIME_FORMAT,
                window.currentCityTimezone
            ).format(WIDGET_DISPLAY_TIME_FORMAT)
            : null;

        return (
            <div className="SH-SearchControls">
                {open && this._renderControls()}
                {!open &&
                    <div className="SH-SearchControls-duration" onClick={this._onHoursClick}>
                        {!isMonthly &&
                            <div className="SH-SearchControls-transient">
                                <div className="SH-SearchControls-transient-timespan">
                                    <div className="SH-SearchControls-transient-starts">
                                        Start Time
                                        <div className="SH-SearchControls-transient-times">{startsFormatted}</div>
                                    </div>
                                    <div className="SH-SearchControls-transient-divider">/</div>
                                    <div className="SH-SearchControls-transient-ends">
                                        End Time
                                        <div className="SH-SearchControls-transient-times">{endsFormatted}</div>
                                    </div>
                                </div>
                                <div className="SH-SearchControls-transient-edit">
                                    <div className="SH-SearchControls-transient-edit-text">
                                        Edit <Icon name="chevron-down" />
                                    </div>
                                </div>
                            </div>
                        }
                        {isMonthly &&
                            <div className="SH-SearchControls-monthly">
                                <div className="SH-SearchControls-monthly-info">
                                    <span className="SH-SearchControls-monthly-begins">
                                        Month Parking Start Date:
                                    </span>
                                    <span className="SH-SearchControls-monthly-date">
                                        {monthlyStartFormatted}
                                    </span>
                                </div>
                                <div className="SH-SearchControls-transient-edit">
                                    <div className="SH-SearchControls-transient-edit-text">
                                        Edit <Icon name="chevron-down" />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
                {destinationData && destinationData.events.length > 0 &&
                    <div
                        className="SH-SearchControls-destination"
                        onClick={onVenueSearchClick}
                    >
                        <div className="SH-SearchControls-destination-content">
                            <h1 className="heading-md">{destinationData.title}</h1>
                            <span>Select an event to find parking.</span>
                        </div>
                        <Icon name="chevron-right" />
                    </div>
                }
            </div>
        );
    }
}

SearchControls.propTypes = {
    serverDateTimeFormat: PropTypes.string.isRequired,
    hourSpan: PropTypes.number.isRequired,
    isMonthly: PropTypes.bool.isRequired,
    searchString: PropTypes.string,
    transientStart: PropTypes.string,
    transientEnd: PropTypes.string,
    monthlyStart: PropTypes.string,
    destinationData: PropTypes.object,
    onMultiOrNoResultsFound: PropTypes.func.isRequired,
    onNewSearch: PropTypes.func.isRequired,
    onVenueSearchClick: PropTypes.func.isRequired
};

SearchControls.defaultProps = {
    searchString: ''
};

export default Config(SearchControls);



// WEBPACK FOOTER //
// ./widget/src/js/components/map/SearchControls.jsx